export default {
    AUTHENTICATED_USER: "authenticated_user",
    FUNDRAISINGPAGE_OWNER: "frp_owner"
}
